export const getPageNameFromPathname = (pathname: string): string => {
    const value = (pathname || '').split('?')[0] || '';

    // https://fanduel.atlassian.net/wiki/spaces/FAW/pages/307759514092/Casino+Amplitude+Migration+-+Page+View
    switch (true) {
        case value === '/':
            return 'home';
        case value.startsWith('/c/hub/'):
            return 'epic_hub';
        case value.startsWith('/c/'):
            return 'category';
        case value.startsWith('/game/'):
            return 'info';
        case value === '/promotions/':
            return 'promotions';
        case value.startsWith('/promotions/'):
            return 'promo_offer';
        default:
            return (value.split('/').filter(Boolean).pop() || '').replace(/-/g, '_');
    }
};
